import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

const Dashboard = () => {
  var user = JSON.parse(localStorage.getItem("user"));

  const [apiData, setApiData] = useState("");
  useEffect(() => {
    async function callApi() {
      const apiResult = await axios.get("https://ultimateapi.hostprohub.com/api/get-edit-customer/" + user.customer_id);
      setApiData(apiResult.data);
    }
    callApi();
  }, [user.customer_id]);
  let navigate = useNavigate();
  /*   var isLoggedIn = false; */

  if (user) {
    /*  isLoggedIn = true; */
  }
  const logout = () => {
    if (user) {
      /* user = JSON.parse(localStorage.getItem("user")); */

      var obj = { token_id: user.token_id };
      if (axios.post("https://ultimateapi.hostprohub.com/api/customer/logout", obj)) {
        localStorage.removeItem("user");

        navigate("/"); //To redirect to Homepage
        /*  window.setTimeout(function () {
          window.location.reload();
        }, 200); */
      }
    } else {
      navigate("/");
    }
    /*   isLoggedIn = false; */
  };
  return (
    <div>
      <div /* className="page-content pt-150 pb-150" */>
        {/*  <div className="container">
          <div className="row">
            <div className="col-lg-10 m-auto">
              <div className="row">  */}

        <div className="row">
          <div className="col-4">
            <div className="profile-sidebar crop-avatar">
              <form
                id="avatar-upload-form"
                enctype="multipart/form-data"
                action="javascript:void(0)"
                onsubmit="if (!window.__cfRLUnblockHandlers) return false; return false"
                data-cf-modified-8044a621228e6f28d3b905a7-=""
              >
                <div className="avatar-upload-container">
                  <div className="form-group mb-0">
                    <div id="account-avatar">
                      <div className="profile-image">
                        <div className="avatar-view mt-card-avatar">
                          <img
                            className="br2 align-middle"
                            /*  src="data:image/png;base64,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" */
                            alt=""
                          />
                          <div className="mt-overlay br2">
                            <span>
                              <i className="fi-rs-edit fs-6"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="print-msg" className="text-danger hidden"></div>
                </div>
              </form>
              <div className="modal fade" id="avatar-modal" tabindex="-1" aria-labelledby="avatar-modal-label" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <form className="avatar-form" method="" action="" enctype="">
                      <div className="modal-header">
                        <h4 className="modal-title" id="avatar-modal-label">
                          <i className="til_img"></i>
                          <strong>Profile Image</strong>
                        </h4>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                        <div className="avatar-body">
                          <div className="avatar-upload">
                            <input className="avatar-src" name="avatar_src" type="hidden" />
                            <input className="avatar-data" name="avatar_data" type="hidden" />
                            <input type="hidden" name="_token" value="P3OROy6xxUUbeksJ80s5aa8NZ1oTfq8O8p3hpwkQ" />
                            <label for="avatarInput">New image</label>
                            <input className="avatar-input avatar-input bg-transparent ms-0" id="avatarInput" name="avatar_file" type="file" />
                          </div>
                          <div className="loading" tabindex="-1" role="img" aria-label="Loading"></div>

                          <div className="row">
                            <div className="col-md-9">
                              <div className="avatar-wrapper"></div>
                              <div className="error-message text-danger" style={{ display: "none" }}></div>
                            </div>
                            <div className="col-md-3 avatar-preview-wrapper">
                              <div className="avatar-preview preview-lg"></div>
                              <div className="avatar-preview preview-md"></div>
                              <div className="avatar-preview preview-sm"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button className="btn btn-small btn-secondary" type="button" data-bs-dismiss="modal" aria-label="Close">
                        Close
                      </button>
                      <button className="btn btn-small btn-primary avatar-save" type="submit">
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="profile-usertitle-name pt-2">
            <strong>{user.customer_name}</strong>{" "}
            <p>
              <small>
                {apiData.customer_email}
                {/* {console.log("Email: " + .customer_email)} */}
              </small>
            </p>
          </div>
        </div>

        <hr />
        <div className="dashboard-menu">
          <ul className="nav flex-column">
            <li className="nav-item">
              <NavLink
                to="/customer/overview"
                className="nav-link"
                activeClassName="nav-link active "
                aria-controls="dashboard"
                aria-selected="false"
              >
                <i className="fi-rs-settings-sliders mr-10" aria-hidden="true"></i>
                Overview
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/customer/edit-account"
                className="nav-link"
                activeClassName="nav-link active "
                aria-controls="dashboard"
                aria-selected="false"
              >
                <i className="fi-rs-edit-alt mr-10" aria-hidden="true"></i>
                Profile
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/customer/orders" className="nav-link" activeClassName="nav-link active " aria-controls="dashboard" aria-selected="false">
                <i className="fi-rs-shopping-bag mr-10" aria-hidden="true"></i>
                Orders
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/customer/address" className="nav-link" activeClassName="nav-link active " aria-controls="dashboard" aria-selected="false">
                <i className="fi-rs-marker mr-10" aria-hidden="true"></i>
                Address books
              </NavLink>
            </li>
            {/*  <li className="nav-item">
              <NavLink to=" " className="nav-link" activeClassName=" " aria-controls="dashboard" aria-selected="false">
                <i className="fi-rs-heart mr-10" aria-hidden="true"></i>
                Wishlist
              </NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink
                to="/customer/changepass"
                className="nav-link"
                activeClassName="nav-link active "
                aria-controls="dashboard"
                aria-selected="false"
              >
                <i className="fi-rs-key mr-10" aria-hidden="true"></i>
                Change password
              </NavLink>
            </li>
            {/*   <li className="nav-item ">
              <NavLink
                to="/customer/becomevendor"
                className="nav-link"
                activeClassName="nav-link active "
                aria-controls="dashboard"
                aria-selected="false"
              >
                <i className="fi-rs-shopping-cart mr-10"></i> Become a vendor
              </NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink
                to="/login"
                className="nav-link"
                activeClassName="nav-link active "
                aria-controls="dashboard"
                aria-selected="false"
                onClick={logout}
              >
                <i className="fi-rs-sign-out mr-10" aria-hidden="true"></i>
                Logout
              </NavLink>
            </li>
          </ul>
        </div>
        {/*       </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;
